export class FileData {
  fileName: string;
  fileType: string;
  fileData: string;
}
